<div class="sx-help-introduction" *ngIf="introductionData">
  <div class="sx-help-introduction__description" *ngIf="introductionData.description" [innerHTML]="introductionData.description | safeHtml" appRouterLink></div>
  <div class="sx-help-introduction__link" *ngFor="let guide of guides; let i = index">
    <a href="javascript:void(0)" (click)="openGuide(guide)" id="intro_link_{{i}}">{{ guide.name }}</a>
    <span>{{ guide.changed | date:'shortDate'}}</span>
  </div>
</div>
